<div class="changelog-entry">
  <div class="entry-dot"></div>

  <div class="entry-content">
    <div class="entry-header">
      <div class="entry-title-row">
        <h3 class="entry-title">{{ entry.title }}</h3>
        <span class="entry-date">{{ entry.date | date : "MMM d, yyyy" }}</span>
      </div>

      <div class="entry-categories">
        @for (category of entry.categories; track category) {
        <span [class]="'category-badge ' + getCategoryClass(category)">
          {{ getCategoryLabel(category) }}
        </span>
        }
      </div>

      <p class="entry-description">{{ entry.description }}</p>

      <button
        class="toggle-details"
        (click)="toggleExpanded()"
        [class.expanded]="expanded"
      >
        {{ expanded ? "Skjul detaljer" : "Vis detaljer" }}
        <span class="toggle-icon">{{ expanded ? "−" : "+" }}</span>
      </button>
    </div>

    <div class="entry-details" [class.expanded]="expanded">
      <ul class="details-list">
        @for (detail of entry.details; track detail) {
        <li>{{ detail }}</li>
        }
      </ul>
    </div>
  </div>
</div>
